module.exports = __webpack_public_path__ + "img/16_mark_s.8c8155ba.png";